module.exports = __webpack_public_path__ + "media/images/landkit/covers/cover-12-18802e840f905325b6a93624c2053e16.jpg";